module.exports = __webpack_public_path__ + "static/img/fireOperate.cfb4aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fireOperate.png
// module id = IGvu
// module chunks = 208